module.exports = __webpack_public_path__ + "captchabg.6a8bc8703bae15c00117.jpg";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/images/captchabg.jpg
// module id = ../../../../../src/assets/images/captchabg.jpg
// module chunks = 2